import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import ConfigurationLocalAssaysSectionsModalBasicForm from '@/modules/configurationModule/detail/local-laboratory-module/sections/components/modal-basic-form/configuration-local-assays-sections-modal-basic-form.vue'
import ConfigurationLocalAssaysSectionsModalOperationsForm from '@/modules/configurationModule/detail/local-laboratory-module/sections/components/modal-operations-form/configuration-local-assays-sections-modal-operations-form.vue'
import ConfigurationLocalAssaysSectionsModalAssaysGroupsForm from '@/modules/configurationModule/detail/local-laboratory-module/sections/components/modal-assays-groups-form/configuration-local-assays-sections-modal-assays-groups-form.vue'
import { BModal } from 'bootstrap-vue'
import { ConfigurationSectionResponse, ConfigurationSectionCreateRequest, ConfigurationSectionPatchInBatchRequest } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'
import { ConfigurationLocalAssaysSectionsModalState, initialConfigurationLocalAssaysSectionsModalState } from '@/modules/configurationModule/detail/local-laboratory-module/sections/components/modal/configuration-local-assays-sections-modal.model'

@Component({
    components: {
        ConfigurationLocalAssaysSectionsModalBasicForm,
        ConfigurationLocalAssaysSectionsModalOperationsForm,
        ConfigurationLocalAssaysSectionsModalAssaysGroupsForm
    }
})
export default class ConfigurationLocalAssaysSectionsModal extends Vue {
    @Ref() readonly configurationLocalAssaysSectionsModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): ConfigurationSectionCreateRequest {
        return {
            active: !!this.state.section.active,
            allowsRealTracking: !!this.state.section.allowsRealTracking,
            allowsTouchMode: !!this.state.section.allowsTouchMode,
            code: this.state.section.code!,
            name: this.state.section.name!,
            priority: this.state.section.priority!
        }
    }

    @Emit()
    update(): ConfigurationSectionPatchInBatchRequest {
        return {
            id: this.state.section.id!,
            active: !!this.state.section.active,
            allowsRealTracking: !!this.state.section.allowsRealTracking,
            allowsTouchMode: !!this.state.section.allowsTouchMode,
            code: this.state.section.code,
            name: this.state.section.name,
            priority: this.state.section.priority
        }
    }

    state: ConfigurationLocalAssaysSectionsModalState

    get updateMode(): boolean {
        return !!this.state.section?.id
    }

    constructor() {
        super()
        this.state = initialConfigurationLocalAssaysSectionsModalState()
    }

    async show(section?: ConfigurationSectionResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationLocalAssaysSectionsModalState()
        if (section) {
            this.state.section = section
        }

        this.configurationLocalAssaysSectionsModal.show()
    }

    hide(): void {
        this.configurationLocalAssaysSectionsModal.hide()
    }
}
